import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import Button from '../../CustomButtons/Button.js';
import HelpRequestIcon from '../../../assets/img/planner-help-icon.svg';
import ChecklistIcon from '../../../assets/img/planner-checklist-icon.svg';
import PlanningMeetingIcon from '../../../assets/img/planner-meeting-icon.svg';
import HousingTradelifeIcon from '../../../assets/img/planner-housing-tradelife-icon.svg';
import ScholarshipsIcon from '../../../assets/img/planner-scholarships-icon.svg';
import RecommendationIcon from '../../../assets/img/planner-recommendations-icon.svg';
import ProactiveCheckinIcon from '../../../assets/img/proactive-contact-icon.svg';
import StudentPlannerIcon from '../../../assets/img/planner-workbook-icon.svg';
import TreeWatermark from '../../../assets/img/tree-watermark.png';
import AwardPayoutRequestsIcon from '../../../assets/img/award-payout-requests.svg';
import PleaseWait from '../../Shared/PleaseWait';
import { showFeature } from '../../../util/featureSwitchUtil';
import SeniorTipsAndLinks from '../SeniorTipsAndLinks';
import AlumniTipsAndLinks from '../AlumniTipsAndLinks';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import HomeIcon from '@material-ui/icons/Home';
import { useHistory } from 'react-router-dom';
import { calculateNumberCompletedModules } from '../../../util/workbookUtils';
import { isAdminOrFHT, isAlumni, isFHT, isStudent, isStudentOrAlumni } from '../../../util/miscUtil';
import PlannerFeatureCard from './PlannerFeatureCard';
import { FEATURE_SWITCH } from '../../../constants/general';

const Home = ({
  senior,
  alumni,
  roles,
  formatPhoneNumber,
  showReturnedAftercareApp,
  showReturnedScholarshipApp,
  aftercareSpecialist,
  showReturnedChecklist,
  showReturnedPlanningForm1,
  showReturnedPlanningForm2,
  setPage,
  navToHelpApps,
  navToAftercareApps,
  navToScholarshipApps,
  navToRecommendations,
  handleReturnToSeniorList,
  classes,
  navToCheckInApps,
  navToWorkbook,
  switches,
  workbookModuleList,
  handleSetButtonColorByStatus,
  fetchButtonCompletionStatus,
  setShowLifeSkills,
  userId,
  isFHTMode,
  navToAwardPaymentRequests,
}) => {
  const [working, setWorking] = useState(false);

  const showWorkbook = senior ? showFeature(switches, 'Senior Planner Workbook', roles[0], userId) : false;
  const showScholarships = senior ? showFeature(switches, 'Scholarships', roles[0], userId) : false;
  const showAftercare = senior ? showFeature(switches, 'Aftercare', roles[0], userId) : false;
  const showChecklist = senior ? showFeature(switches, 'Senior Checklist', roles[0], userId) : false;
  const showPlanningForm1 = senior ? showFeature(switches, 'Senior Planner Planning Form 1', roles[0], userId) : false;
  const showPlanningForm2 = senior ? showFeature(switches, 'Senior Planner Planning Form 2', roles[0], userId) : false;
  const showLettersOfRec = senior ? showFeature(switches, 'Letters of Recommendation', roles[0], userId) : false;
  const showAwardPaymentRequest = senior ? showFeature(switches, FEATURE_SWITCH.AWARD_PAYMENT, roles[0], userId) : false;

  const [pageLoaded, setPageLoaded] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (switches && switches.length > 0) {
      if (senior) {
        setPageLoaded(true);
      }
    }
  }, [senior, switches]);

  const getWorkbookCompletionStatus = () => {
    let foundNotStarted = true;
    let foundRegistered = false;
    let foundCompleted = true;
    if (workbookModuleList && workbookModuleList.length > 0) {
      workbookModuleList.forEach((mod) => {
        mod?.steps?.forEach((step) => {
          step.courses.forEach((course) => {
            if (course.completed === undefined) {
              if (foundCompleted) {
                foundCompleted = false;
              }
            }
            if (course.registered) {
              if (!foundRegistered) {
                foundNotStarted = false;
                foundRegistered = true;
              }
            }
          });
        });
      });
    } else {
      return '';
    }

    if (foundNotStarted) {
      return 'notstarted';
    } else if (foundRegistered) {
      return 'started';
    } else if (foundCompleted) {
      return 'completed';
    }
  };

  const handlePageChange = (page) => {
    setWorking(true);
    setPage(page);
    setWorking(false);
  };

  const canSeePlanningTiles = () => {
    if (!senior || !senior.user || !senior.user.email) return false;
    if (isAdminOrFHT(roles)) {
      if (alumni) {
        return senior.allow_alumni_planning;
      } else {
        return true;
      }
    } else if (isAlumni(roles)) {
      return senior.allow_alumni_planning;
    } else {
      return true;
    }
  };

  const verifyStudent = () => {
    return !!isStudent(roles);
  };

  const verifyAlumni = () => {
    return !!isAlumni(roles);
  };

  const verifyAdmin = () => {
    return !!isAdminOrFHT(roles);
  };

  const verifyAdminForStudent = () => {
    if (isAdminOrFHT(roles)) {
      if (!alumni) {
        return true;
      }
    }
    return false;
  };

  const verifyStudentOrAdminForStudent = () => {
    if (isStudent(roles)) {
      return true;
    } else if (isAdminOrFHT(roles)) {
      if (!alumni) {
        return true;
      }
    }
    return false;
  };

  const verifyAdminForAlumni = () => {
    if (isAdminOrFHT(roles)) {
      if (alumni) {
        return true;
      }
    }
    return false;
  };

  const verifyAlumniOrAdminForAlumni = () => {
    if (isAlumni(roles)) {
      return true;
    } else if (isAdminOrFHT(roles)) {
      if (alumni) {
        return true;
      }
    }
    return false;
  };

  const showPlanningHeader = () => {
    if (isStudent(roles)) {
      return true;
    } else if (isAlumni(roles)) {
      if (canSeePlanningTiles()) {
        return true;
      } else {
        return false;
      }
    } else if (isAdminOrFHT(roles)) {
      if (alumni) {
        if (canSeePlanningTiles()) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
    return false;
  };

  const isAdminUser = verifyAdmin();
  const isCurrentUserStudentOrAlumni = isStudentOrAlumni(roles);
  const hasValidUser = senior?.user?.id > 0;
  const canShowAwardPaymentCard = hasValidUser && ((isAdminUser && (senior || alumni)) || isCurrentUserStudentOrAlumni);

  return (
    <>
      <div className={classes.fullWidthBanner}>
        <div style={{ width: '1320px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
          {/* ************* BEGIN: Senior Header ************* */}
          {senior && (verifyStudent() || verifyAlumni()) && (
            <Grid item xs={12} className={classes.welcomeGrid}>
              <Grid container spacing={3} direction='row' className={classes.homeBannerContent}>
                <Grid item xs={12} sm={12} md={6} lg={7} className={classes.seniorGrid}>
                  {verifyAlumni() ? (
                    <Typography variant='h4' className={classes.welcome}>
                      Welcome, {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}
                    </Typography>
                  ) : (
                    <Typography variant='h4' className={classes.welcome}>
                      Welcome, {senior.first_name}
                    </Typography>
                  )}
                  <div className={classes.specialistGrid}>
                    {(verifyStudent() || verifyAlumni()) && (
                      <>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Successful Futures Specialist:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.user && aftercareSpecialist.user.id > 0
                              ? aftercareSpecialist.user.first_name + ' ' + aftercareSpecialist.user.last_name
                              : 'N/A'}
                          </span>
                        </section>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Office Phone:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.office_phone ? formatPhoneNumber(aftercareSpecialist.office_phone) : 'N/A'}
                          </span>
                        </section>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Cell Phone:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.cell_phone ? formatPhoneNumber(aftercareSpecialist.cell_phone) : 'N/A'}
                          </span>
                        </section>
                      </>
                    )}
                    {senior && senior.user && senior.user.email && (
                      <Grid container direction='row'>
                        <Grid item xs={12} sm={5} md={6} lg={5} align='left'>
                          <Button
                            className={classes.headerButton}
                            color='secondary'
                            variant='contained'
                            round
                            onClick={() => handlePageChange('basicinfo')}
                          >
                            {verifyAlumni() ? 'Edit Contact Info' : 'Edit My Personal Info'}
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={7} md={6} lg={7} align='left'>
                          {verifyStudent() && (
                            <Button
                              className={classes.wideHeaderButton}
                              color='reddit'
                              variant='contained'
                              round
                              onClick={() => setShowLifeSkills(true)}
                            >
                              Open Adv Life Skills Schedule
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    )}
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={5}
                  align='right'
                  className={classes.watermarkBackground}
                  style={{
                    backgroundColor: 'transparent',
                    backgroundImage: 'url(' + TreeWatermark + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '110%',
                  }}
                ></Grid>
              </Grid>
            </Grid>
          )}
          {/* ************* END: Senior Header ************* */}

          {/* ************* BEGIN: Admin Header ************* */}
          {verifyAdmin() && senior && senior.user && senior.user.email && (
            <Grid item xs={12} className={classes.welcomeGrid}>
              <Grid container spacing={3} direction='row'>
                <Grid item xs={12} sm={12} md={6} lg={7}>
                  {verifyAdminForStudent() && (
                    <Typography variant='h4' className={classes.welcome}>
                      {senior.first_name} {senior.last_name}
                    </Typography>
                  )}
                  {verifyAdminForAlumni() && (
                    <Typography variant='h4' className={classes.welcome}>
                      {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                      {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                    </Typography>
                  )}
                  <div className={classes.specialistGrid}>
                    {(verifyAdminForStudent() || verifyAdminForAlumni()) && (
                      <>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Successful Futures Specialist:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.user && aftercareSpecialist.user.id > 0
                              ? aftercareSpecialist.user.first_name + ' ' + aftercareSpecialist.user.last_name
                              : 'N/A'}
                          </span>
                        </section>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Office Phone:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.office_phone ? formatPhoneNumber(aftercareSpecialist.office_phone) : 'N/A'}
                          </span>
                        </section>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Cell Phone:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.cell_phone ? formatPhoneNumber(aftercareSpecialist.cell_phone) : 'N/A'}
                          </span>
                        </section>
                      </>
                    )}
                    {verifyAdminForAlumni() && <br />}
                    {senior && senior.user && senior.user.email && (
                      <Grid container direction='row' className={classes.headerButtonContainer} style={{ width: '100%' }}>
                        <Grid item xs={12} sm={5} md={6} lg={5} align='left' style={{ width: '100%' }}>
                          <Button
                            className={classes.headerButton}
                            color='secondary'
                            variant='contained'
                            round
                            onClick={(event) => handlePageChange('basicinfo')}
                          >
                            {verifyAlumni() ? 'Edit Contact Info' : 'Edit My Personal Info'}
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={7} md={6} lg={7} align='left' style={{ width: '100%' }}>
                          {verifyAdminForStudent() && (
                            <Button
                              className={classes.wideHeaderButton}
                              color='reddit'
                              variant='contained'
                              round
                              onClick={(event) => setShowLifeSkills(true)}
                            >
                              Open Adv Life Skills Schedule
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    )}
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={5}
                  align='right'
                  className={classes.watermarkBackground}
                  style={{
                    backgroundColor: 'transparent',
                    backgroundImage: 'url(' + TreeWatermark + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '120%',
                  }}
                ></Grid>
              </Grid>
            </Grid>
          )}
          {/* ************* END: Admin Header ************* */}

          {/* ************* BEGIN: Admin for Inactive Students Header ************* */}
          {verifyAdmin() && senior && senior.user && !senior.user.id && (
            <Grid item xs={12} className={classes.welcomeGrid}>
              <Grid container spacing={3} direction='row'>
                <Grid item xs={12} sm={12} md={6} lg={7}>
                  {verifyAdminForStudent() && (
                    <Typography variant='h4' className={classes.welcome}>
                      {senior.first_name} {senior.last_name}
                    </Typography>
                  )}
                  {verifyAdminForAlumni() && (
                    <Typography variant='h4' className={classes.welcome}>
                      {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                      {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                    </Typography>
                  )}
                  <Typography variant='h6' className={classes.inactiveSubLabel}>
                    <em>Inactive</em>
                  </Typography>
                  <div className={classes.specialistGrid}>
                    {(verifyAdminForStudent() || verifyAdminForAlumni()) && (
                      <>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Successful Futures Specialist:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.user && aftercareSpecialist.user.id > 0
                              ? aftercareSpecialist.user.first_name + ' ' + aftercareSpecialist.user.last_name
                              : 'N/A'}
                          </span>
                        </section>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Office Phone:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.office_phone ? formatPhoneNumber(aftercareSpecialist.office_phone) : 'N/A'}
                          </span>
                        </section>
                        <section style={{ textAlign: 'left' }}>
                          <label className={classes.contactInfoLabel}>Cell Phone:</label>{' '}
                          <span className={classes.contactInfo}>
                            {aftercareSpecialist && aftercareSpecialist.cell_phone ? formatPhoneNumber(aftercareSpecialist.cell_phone) : 'N/A'}
                          </span>
                        </section>
                      </>
                    )}
                    <br />
                    <Grid container direction='row' className={classes.headerButtonContainer} style={{ width: '100%' }}>
                      <Grid item xs={12} sm={5} md={6} lg={5} align='left' style={{ width: '100%' }}>
                        <Button
                          className={classes.headerButton}
                          color='secondary'
                          variant='contained'
                          round
                          onClick={(event) => handlePageChange('basicinfo')}
                        >
                          {verifyAlumni() ? 'Edit Contact Info' : 'Edit My Personal Info'}
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={5}
                  align='right'
                  className={classes.watermarkBackground}
                  style={{
                    backgroundColor: 'transparent',
                    backgroundImage: 'url(' + TreeWatermark + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '120%',
                  }}
                ></Grid>
              </Grid>
            </Grid>
          )}
          {/* ************* END: Admin for Inactive Students Header ************* */}
        </div>
      </div>
      <div className={classes.greetingContainer}>
        <PleaseWait isLoading={working} />

        {pageLoaded && (
          <Grid container spacing={3} direction='row' className={classes.homeHeader}>
            {verifyAdminForStudent() && senior && senior.user && senior.user.email && (
              <div className={classes.breadcrumbs}>
                <Breadcrumbs separator='›' aria-label='breadcrumbs' className={classes.alignCrumb}>
                  <span data-testid='home-breadcrumb' className={classes.breadCrumbLink} onClick={(event) => history.push('/')}>
                    <HomeIcon style={{ fontSize: '1.30rem', marginTop: '-1px' }} />
                    <span style={{ margin: '0 0 0 1px' }}>Home</span>
                  </span>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(event) => handleReturnToSeniorList()}>
                    High School Seniors
                  </span>
                  <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                    {senior && senior.first_name + ' ' + senior.last_name}
                  </span>
                </Breadcrumbs>
              </div>
            )}

            {verifyAdminForAlumni() && (
              <div className={classes.breadcrumbs}>
                <Breadcrumbs separator='›' aria-label='breadcrumbs' className={classes.alignCrumb}>
                  <span className={classes.breadCrumbLink} onClick={(event) => history.push('/')}>
                    <HomeIcon style={{ fontSize: '1.30rem', marginTop: '-1px' }} />
                    <span style={{ margin: '0 0 0 1px' }}>Home</span>
                  </span>
                  <span className={classes.breadCrumbLink} onClick={(event) => handleReturnToSeniorList()}>
                    Alumni
                  </span>
                  <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                    {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                    {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                  </span>
                </Breadcrumbs>
              </div>
            )}

            {verifyAlumniOrAdminForAlumni() && (
              <div className={classes.restrictPageWidth}>
                <Grid container spacing={5} direction='row' className={classes.alumniHeadline}>
                  <Grid item xs={12} sm={12} md={6} lg={6} className={classes.largeInfo}>
                    <div className={classes.largeInfoGold}>Designed to assist you</div>
                    <div className={classes.largeInfoBlue}>in making and implementing informed educational and occupational choices</div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} align='left' className={classes.smallInfo}>
                    This includes coordinating the distribution of need-based and merit scholarships to outstanding and qualified students pursuing
                    undergraduate and trade degrees, and coordinating the implementation of learning experiences (internships, apprenticeships,
                    shadowing, volunteering, and other career-oriented opportunities) to improve career decision making.{' '}
                    <strong>Click on a card below to get started!</strong>
                  </Grid>
                </Grid>
                <div style={{ width: '100%', marginTop: '30px' }}>
                  <hr className={classes.divider} />
                </div>
              </div>
            )}

            {/* ************* Senior Notifications ************* */}
            {verifyStudent() && (
              <div className={classes.restrictPageWidth}>
                <Grid container spacing={3} direction='row' align='left' className={classes.notficationArea}>
                  <Grid item xs={12} align='left'>
                    {showReturnedChecklist && (
                      <aside className={classes.error}>NOTE: You have a returned Checklist. Please review immediately!</aside>
                    )}
                    {showReturnedPlanningForm1 && (
                      <aside className={classes.returnedToastMessage}>NOTE: You have a returned Planning Form #1. Please review immediately!</aside>
                    )}
                    {showReturnedPlanningForm2 && (
                      <aside className={classes.returnedToastMessage}>NOTE: You have a returned Planning Form #2. Please review immediately!</aside>
                    )}
                    {showReturnedAftercareApp && (
                      <aside className={classes.returnedToastMessage}>
                        NOTE: You have a returned Community Supports/Housing application. Please review immediately!
                      </aside>
                    )}
                    {showReturnedScholarshipApp && (
                      <aside className={classes.returnedToastMessage}>
                        NOTE: You have a returned Scholarship application. Please review immediately!
                      </aside>
                    )}
                  </Grid>
                </Grid>
              </div>
            )}

            {/* ************* Alumni Notifications ************* */}
            {verifyAlumni() && (
              <div className={classes.restrictPageWidth}>
                <Grid container spacing={3} direction='row' align='left' className={classes.notficationArea}>
                  <Grid item xs={12} align='left'>
                    {showReturnedAftercareApp && (
                      <aside className={classes.returnedToastMessage}>
                        NOTE: You have a returned Community Supports/Housing application. Please review immediately!
                      </aside>
                    )}
                    {showReturnedScholarshipApp && (
                      <aside className={classes.returnedToastMessage}>
                        NOTE: You have a returned Scholarship application. Please review immediately!
                      </aside>
                    )}
                  </Grid>
                </Grid>
              </div>
            )}
          </Grid>
        )}

        {pageLoaded && (
          <div style={{ width: '100%' }}>
            {senior && senior.user && senior.user.email && showPlanningHeader() && (
              <div className={classes.sectionHeading}>Planning for My Future</div>
            )}
            {/* Unregistered User */}
            {(!senior || !senior.user || !senior.user.email) && (
              <div className={classes.notification}>Student is not a registered Successful Futures user!</div>
            )}
            {/* ************* Page 1 Cards - Row 1 ************* */}
            {canSeePlanningTiles() && (
              <div className={classes.centerHomeCards}>
                <Grid container spacing={3} direction='row' className={classes.menuRestricted}>
                  <Grid item xs={12} className={classes.cardGrid}>
                    {senior && senior.user && senior.user.email && showWorkbook && (
                      <Card className={classes.card}>
                        <CardBody className={classes.cardBody}>
                          <div className={classes.cardContainer}>
                            <img src={StudentPlannerIcon} alt='Student Workbook Icon' className={classes.cardIcon} />
                            <section className={classes.menuTitle}>
                              <span className={classes.cardHeader}>My Planning Workbook</span>
                            </section>
                            <aside className={classes.menuDesc}>
                              Watch the videos and dive into the exercises to start building your path to independence.{' '}
                              {!isFHT(roles) &&
                                verifyAdmin() &&
                                (workbookModuleList?.length > 0 ? (
                                  <span className={classes.cardCompletionStat}>
                                    Modules Completed: {calculateNumberCompletedModules(workbookModuleList)}/{workbookModuleList.length}
                                  </span>
                                ) : (
                                  <span className={classes.cardCompletionStat}>No modules assigned.</span>
                                ))}
                            </aside>
                          </div>
                          {!isFHTMode ? (
                            <>
                              {workbookModuleList && workbookModuleList.length > 0 ? (
                                <Button
                                  className={classes.cardButton}
                                  color={handleSetButtonColorByStatus(getWorkbookCompletionStatus())}
                                  variant='contained'
                                  round
                                  onClick={() => navToWorkbook()}
                                >
                                  <a style={{ color: 'rgba(0, 85, 128, 1)' }}>{fetchButtonCompletionStatus(getWorkbookCompletionStatus())}</a>
                                </Button>
                              ) : (
                                <Button
                                  className={classes.cardButton}
                                  color={handleSetButtonColorByStatus(getWorkbookCompletionStatus())}
                                  variant='contained'
                                  round
                                  onClick={() => navToWorkbook()}
                                >
                                  <a style={{ color: 'rgba(0, 85, 128, 1)' }}>View</a>
                                </Button>
                              )}
                            </>
                          ) : (
                            <Button className={classes.cardButton} color='primary' variant='contained' round onClick={() => navToWorkbook()}>
                              View
                            </Button>
                          )}
                        </CardBody>
                      </Card>
                    )}

                    {showChecklist && (
                      <PlannerFeatureCard
                        classes={classes}
                        iconSrc={ChecklistIcon}
                        iconAlt='Checklist Icon'
                        title='Planning Checklist'
                        description='Maintain your checklist for completing your senior planning.'
                        buttonLabel={verifyAdmin() ? 'View' : 'Edit / View'}
                        onButtonClick={() => handlePageChange('checklist')}
                      />
                    )}
                    {showPlanningForm1 && (
                      <PlannerFeatureCard
                        classes={classes}
                        iconSrc={PlanningMeetingIcon}
                        iconAlt='Planning Meeting 1 Icon'
                        title='Planning Meeting #1'
                        description='Complete your Planning Form for meeting #1 typically held in the fall of your senior year.'
                        buttonLabel={verifyAdmin() ? 'View' : 'Edit / View'}
                        onButtonClick={() => handlePageChange('planning1')}
                      />
                    )}
                    {showPlanningForm2 && (
                      <PlannerFeatureCard
                        classes={classes}
                        iconSrc={PlanningMeetingIcon}
                        iconAlt='Planning Meeting 2 Icon'
                        title='Planning Meeting #2'
                        description='Complete your Planning Form for meeting #2 typically held in the winter of your senior year.'
                        buttonLabel={verifyAdmin() ? 'View' : 'Edit / View'}
                        onButtonClick={() => handlePageChange('planning2')}
                      />
                    )}
                  </Grid>
                </Grid>
              </div>
            )}
            {senior && senior.user && senior.user.email && showPlanningHeader() && <hr className={classes.divider} />}
            {senior && senior.user && senior.user.email && verifyStudentOrAdminForStudent() && (
              <div className={classes.sectionHeading}>Applications and Letters of Recommendation</div>
            )}
            {senior && senior.user && senior.user.email && verifyAlumni() && (
              <div className={classes.sectionHeading}>Help Requests, Applications and Letters of Recommendation</div>
            )}
            {verifyAdminForAlumni() && (
              <div className={classes.sectionHeading}>Help Requests, Applications, Letters of Recommendation and Check-Ins</div>
            )}
            {/* ************* Page 1 Cards - Row 2 ************* */}
            <div className={classes.centerHomeCards}>
              <Grid container spacing={3} direction='row' className={classes.menuRestricted}>
                <Grid item xs={12} className={classes.cardGrid}>
                  {verifyAlumniOrAdminForAlumni() && (
                    <PlannerFeatureCard
                      classes={classes}
                      iconSrc={HelpRequestIcon}
                      iconAlt='Help Requests Icon'
                      title='Help Requests'
                      description='Contact Boys Town for help with financials, employment, housing, health care, or other questions.'
                      buttonLabel={verifyAdmin() ? 'View' : 'Request Help'}
                      onButtonClick={navToHelpApps}
                    />
                  )}
                  {/* Registered Users (Seniors) */}
                  {senior && senior.user && senior.user.email && (
                    <>
                      {showAftercare && (
                        <PlannerFeatureCard
                          classes={classes}
                          iconSrc={HousingTradelifeIcon}
                          iconAlt='Housing and Community Supports Icon'
                          title='Housing / Community Supports Application'
                          description='Complete the application for Community Supports and Housing services.'
                          buttonLabel={verifyAdmin() ? 'View' : 'Apply / View'}
                          onButtonClick={navToAftercareApps}
                        />
                      )}
                      {showScholarships && (
                        <PlannerFeatureCard
                          classes={classes}
                          iconSrc={ScholarshipsIcon}
                          iconAlt='Scholarships Icon'
                          title='Scholarship Applications'
                          description='Complete an application for Boys Town scholarships.'
                          buttonLabel={verifyAdmin() ? 'View' : 'Apply / View'}
                          onButtonClick={navToScholarshipApps}
                        />
                      )}
                    </>
                  )}
                  {senior && senior.user && senior.user.id > 0 && (
                    <div>
                      {showLettersOfRec && (
                        <PlannerFeatureCard
                          classes={classes}
                          iconSrc={RecommendationIcon}
                          iconAlt='Letters of Recommendation Icon'
                          title='Letters of Recommendation'
                          description='View your pending letters of recommendation.'
                          buttonLabel={verifyAdmin() ? 'View' : 'Request / View'}
                          onButtonClick={navToRecommendations}
                          cardBodyStyle={{ position: 'relative' }}
                        />
                      )}
                    </div>
                  )}

                  {canShowAwardPaymentCard && showAwardPaymentRequest && (
                    <PlannerFeatureCard
                      classes={classes}
                      iconSrc={AwardPayoutRequestsIcon}
                      iconAlt='Award Payout Requests Icon'
                      title='Award Payout Requests'
                      description='Request payment from your Successful Futures awards.'
                      buttonLabel={isAdminUser ? 'View' : 'Request / View'}
                      onButtonClick={navToAwardPaymentRequests}
                      cardBodyStyle={{ position: 'relative' }}
                    />
                  )}
                  {verifyAdminForAlumni() && (
                    <PlannerFeatureCard
                      classes={classes}
                      iconSrc={ProactiveCheckinIcon}
                      iconAlt='Check-In Icon'
                      title='Proactive Check-Ins'
                      description='Check-In with Alumni 3 months and 12 months post-graduation to see how they are doing.'
                      buttonLabel='View'
                      onButtonClick={navToCheckInApps}
                    />
                  )}
                </Grid>
              </Grid>
            </div>
            {pageLoaded && verifyAdmin() && (
              <div className={classes.centerMenu}>
                <div className={classes.adminReturnButtonContainer}>
                  <Button link onClick={(event) => handleReturnToSeniorList()} className={classes.returnButton}>
                    <a style={{ color: 'rgba(0, 85, 128, 1)' }}>
                      <u>{alumni ? 'RETURN TO ALUMNI LIST' : 'RETURN TO SENIORS LIST'}</u>
                    </a>
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {pageLoaded && verifyStudentOrAdminForStudent() && (
        <div className={classes.tipsBackground}>
          <summary className={classes.tipsFrame}>
            <Card className={classes.tipsCard}>
              <CardBody className={classes.tipsCardBody}>
                <div className={classes.sectionHeadingLeft}>Tips, Links and Information</div>
                <SeniorTipsAndLinks />
              </CardBody>
            </Card>
          </summary>
        </div>
      )}

      {pageLoaded && verifyAlumniOrAdminForAlumni() && (
        <div className={classes.tipsBackground}>
          <summary className={classes.tipsFrame}>
            <Card className={classes.tipsCard}>
              <CardBody className={classes.tipsCardBody}>
                <div className={classes.sectionHeadingLeft}>Tips, Links and Information</div>
                <AlumniTipsAndLinks />
              </CardBody>
            </Card>
          </summary>
        </div>
      )}
    </>
  );
};

Home.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  formatPhoneNumber: PropTypes.func,
  showReturnedAftercareApp: PropTypes.bool,
  showReturnedScholarshipApp: PropTypes.bool,
  aftercareSpecialist: PropTypes.object,
  showReturnedChecklist: PropTypes.bool,
  showReturnedPlanningForm1: PropTypes.bool,
  showReturnedPlanningForm2: PropTypes.bool,
  setPage: PropTypes.func,
  navToHelpApps: PropTypes.func,
  navToAftercareApps: PropTypes.func,
  navToScholarshipApps: PropTypes.func,
  navToRecommendations: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  classes: PropTypes.object.isRequired,
  navToCheckInApps: PropTypes.func,
  navToAwardPaymentRequests: PropTypes.func,
  workbookModuleList: PropTypes.array,
  handleSetButtonColorByStatus: PropTypes.func.isRequired,
  fetchButtonCompletionStatus: PropTypes.func.isRequired,
  setShowLifeSkills: PropTypes.func.isRequired,
};

export default Home;
